module.exports = __webpack_public_path__ + "img/vv_logo.84475685.png";